/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../../../../api/index';
import * as core from '../../../../../core';
import * as serializers from '../../../../index';
import { CredentialSchemaCreate } from '../../../../types/CredentialSchemaCreate';

export const SchemaCreateRequest: core.serialization.Schema<
    serializers.SchemaCreateRequest.Raw,
    Omit<Truvity.SchemaCreateRequest, 'idempotencyKey'>
> = core.serialization.object({
    annotations: core.serialization.record(core.serialization.string(), core.serialization.string()).optional(),
    data: CredentialSchemaCreate,
    labels: core.serialization.record(core.serialization.string(), core.serialization.string()).optional(),
});

export declare namespace SchemaCreateRequest {
    export interface Raw {
        annotations?: Record<string, string> | null;
        data: CredentialSchemaCreate.Raw;
        labels?: Record<string, string> | null;
    }
}
